import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { HeaderComponent } from '../components/header/header.component';
import { FooterComponent } from '../components/footer/footer.component';
import { CompactFooterComponent } from '../components/compact-footer/compact-footer.component';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
  imports: [HeaderComponent, FooterComponent, CompactFooterComponent, TranslatePipe],
})
export class ShellComponent {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  private footerType = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => this.getRouteData('footerType'))
    ),
    { initialValue: this.getRouteData('footerType') }
  );

  useCompactFooter = () => this.footerType() === 'compact';
  hideFooter = () => this.footerType() === 'none';

  private getRouteData(key: string): string | undefined {
    let route = this.activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot.data[key];
  }
}
